import { Card } from '@newcore/ui/card';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { Text } from '@newcore/ui/typography';
import type { DiagnoseMcpServerResponse } from '@/api/user-portal-api-generated';
import { IMPLEMENTATION_GUIDES } from '../constants/mcp-tester-content';
import { CapabilityCard } from './capability-card';
import { DocLinks } from './doc-links';
import { StepRow } from './step-row';
import { Verdict } from './verdict';

interface DiagnosisReportProps {
  result: DiagnoseMcpServerResponse;
  serverUrl: string;
}

export function DiagnosisReport({ result, serverUrl }: DiagnosisReportProps) {
  const steps = result.steps ?? [];

  return (
    <div className='flex flex-col gap-6' data-testid='mcp-tester-report'>
      <Verdict result={result} serverUrl={serverUrl} />

      {result.client_type && (
        <CapabilityCard
          clientType={result.client_type}
          displayName={result.display_name ?? ''}
          scopes={result.scopes ?? []}
          documentationUrl={result.documentation_url ?? ''}
          redirectUri={result.redirect_uri ?? ''}
        />
      )}

      <Card className='p-4'>
        <Text as='p' weight={FontWeights.SEMIBOLD} className='text-primary'>
          What we checked
        </Text>
        <ul className='pt-2'>
          {steps.map(step => (
            <StepRow key={step.step} step={step} />
          ))}
        </ul>
      </Card>

      <Card className='p-4'>
        <Text as='p' weight={FontWeights.SEMIBOLD} className='text-primary'>
          Adding authorization to your server
        </Text>
        <Text as='p' className='text-tertiary'>
          MCP authorization is OAuth 2.1 plus two discovery documents. These
          cover the common server stacks.
        </Text>
        <DocLinks links={IMPLEMENTATION_GUIDES} />
      </Card>
    </div>
  );
}
